import React, { useEffect } from 'react';
import { observer, useLocalObservable } from 'mobx-react-lite';
import { Page } from '../../../mainv3/components/atoms/applications/page';
import '../../../mainv3/containers/attendances/eventReservationAttendancePage.module.scss';
import { LoaderRow } from '../../../mainv3/components/atoms/layout/LoaderRow';
import { authenticated } from '../../../mainv3/components/hocs/authenticated';
import { EventReservationAttendanceCompletePageState } from '../../../mainv3/containers/attendances/states/EventReservationAttendanceCompletePageState';
import { EventReservationId } from '../../../commonv3/types/eventReservations';
import { ReservationCard } from '../../../mainv3/components/molecules/reservations/ReservationCard';

type Props = {
  match: {
    params: {
      eventReservationId: EventReservationId;
    };
  };
};

export const EventReservationAttendanceCompletePage = authenticated(
  observer((props: Props) => {
    const { pageState } = useLocalObservable(() => ({ pageState: new EventReservationAttendanceCompletePageState() }));

    useEffect(() => {
      const { eventReservationId } = props.match.params;
      pageState.init(eventReservationId);
    }, []);

    const { loading, eventReservation } = pageState;
    const index = 1;
    return (
      <Page>
        {loading ? (
          <LoaderRow />
        ) : (
          <div>
            <div styleName="body">
              <div styleName="header">
                <div styleName="title">出席完了</div>
              </div>
              <ReservationCard
                reservation={eventReservation.get()}
                index={index}
                showButton={false}
                onRequestUpdate={() => null}
              />
            </div>
          </div>
        )}
      </Page>
    );
  })
);
